import {useTranslation} from 'react-i18next';
import {TShow} from '../../../../hooks/useShow';
import SheetShell from '../../components/SheetShell/SheetShell';
import {useSubscriptionList} from '../useSubscriptionList';
import MemberEventRow from './MemberEventRow';
import MemberListLoader from '../memberListLoader/MemberListLoader';
import MemberListError from '../memberListError/MemberListError';
import * as css from './MemberRedeemSheet.css';

interface MemberRedeemSheetProps {
    show: TShow;
    qid: number;
}

/* "Tickets to redeem" — the subscription events, each leading to its purchase page */
function MemberRedeemSheet({show, qid}: MemberRedeemSheetProps) {
    const {t} = useTranslation('eTicket');
    const {items: events, isLoading, hasError, retry, onScroll} = useSubscriptionList('events', qid, show.isOpen);

    return (
        <SheetShell show={show} title={t('redeemTicketsTitle')} data-cy="member-redeem-sheet">
            {events?.length ? (
                <css.list onScroll={onScroll}>
                    {events.map(event => (
                        <MemberEventRow key={event.eid} event={event} />
                    ))}
                    {isLoading && <MemberListLoader data-cy="member-redeem-loader" />}
                    {hasError && <MemberListError onRetry={retry} data-cy="member-redeem-error" />}
                </css.list>
            ) : isLoading ? (
                <MemberListLoader initial data-cy="member-redeem-loader" />
            ) : hasError ? (
                <MemberListError initial onRetry={retry} data-cy="member-redeem-error" />
            ) : (
                <css.empty>{t('noSubscriptionEvents')}</css.empty>
            )}
        </SheetShell>
    );
}

export default MemberRedeemSheet;
